<div class="lang-root" [class.horizontal]="isHorizontal">
  <span class="selected" [class.d-none]="isHorizontal">
    <i [class]="selectedItem.icon"></i><span class="selected-language-code">{{ selectedItem.name }}</span>
  </span>
  <span class="mr-2" [class.d-none]="!isHorizontal">{{ 'LANGUAGE_TEXT' | translate }}:</span>
  <ul class="lang-selection">
    @for (item of itemsSource; track item) {
      <li>
        <i [class]="item.icon" [class.selectedItem]="item.id === selectedItem.id" (click)="select(item.id)"></i>
      </li>
    }
  </ul>
</div>
